import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
import ItemList from 'flarum/common/utils/ItemList';
import Mithril, { Vnode } from 'mithril';
import { getErrorMessage } from '../../common/utils';


export default class LayaForgotPasswordModal extends Modal {
  phone!: Stream<string>;
  code!: Stream<string>;
  password!: Stream<string>;
  loading: boolean = false;

  oninit(vnode: Vnode) {
    super.oninit(vnode);
    this.phone = Stream('');
    this.code = Stream('');
    this.password = Stream('');
  }
  className() {
    return 'LayaForgotPasswordModal Modal--small';
  }

  title() {
    return app.translator.trans('core.forum.forgot_password.title');
  }

  content() {
    return m('.Modal-body', [
      m('form', { onsubmit: this.onsubmit.bind(this), autocomplete: 'off' }, [
        m('.Form.Form--centered', [
          ...this.fields().toArray(),
          m('.Form-group', [
            m(Button, {
              className: 'Button Button--primary Button--block',
              type: 'submit',
              loading: this.loading,
            }, app.translator.trans('core.forum.forgot_password.dismiss_button')),
          ]),
        ]),
      ]),
    ]);
  }

  fields(): ItemList<Mithril.Vnode> {
    const items = new ItemList<Mithril.Vnode>();

    items.add('phone',
      m('.Form-group', [
        m('input.FormControl', {
          name: 'phone',
          type: 'tel',
          placeholder: app.translator.trans('laya-auth.forum.sign_up.phone_placeholder'),
          oninput: (e: Event) => this.phone((e.target as HTMLInputElement).value),
          value: this.phone(),
          disabled: this.loading,
          autocomplete: 'off',
        }),
      ]), 100
    );

    items.add('code',
      m('.Form-group', [
        m('div', { style: { display: 'flex' } }, [
          m('input.FormControl', {
            name: 'code',
            type: 'text',
            placeholder: app.translator.trans('laya-auth.forum.sign_up.code_placeholder'),
            oninput: (e: Event) => this.code((e.target as HTMLInputElement).value),
            value: this.code(),
            disabled: this.loading,
            style: { flex: 1, marginRight: '10px' },
            autocomplete: 'off',
          }),
          m(Button, {
            className: 'Button',
            onclick: this.sendCode.bind(this),
            loading: this.loading,
          }, app.translator.trans('laya-auth.forum.sign_up.send_code_button')),
        ]),
      ]), 90
    );

    items.add('password',
      m('.Form-group', [
        m('input.FormControl', {
          name: 'password',
          type: 'password',
          placeholder: app.translator.trans('laya-auth.forum.sign_up.password_placeholder'),
          oninput: (e: Event) => this.password((e.target as HTMLInputElement).value),
          value: this.password(),
          disabled: this.loading,
          autocomplete: 'new-password',
        }),
      ]), 80
    );

    return items;
  }

  sendCode() {
    if (!this.phone()) {
      app.alerts.show({ type: 'error' }, app.translator.trans('laya-auth.forum.sign_up.phone_required_alert'));
      return;
    }

    this.loading = true;
    m.redraw();

    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/laya/send-code',
      body: { phone: this.phone(), scene: 'forgot' },
      errorHandler: (error: any) => {
        this.loading = false;
        m.redraw();
        // 尝试多种方式获取 ret 错误码和 msg
        const ret = error?.response?.ret ?? error?.responseJSON?.ret ?? error?.body?.ret ?? error?.ret;
        const msg = error?.response?.msg ?? error?.responseJSON?.msg ?? error?.body?.msg ?? error?.msg;
        if (ret !== undefined && ret !== null) {
          app.alerts.show({ type: 'error' }, getErrorMessage(ret, msg));
          return;
        }
        this.onerror(error);
      },
    }).then((response: any) => {
      this.loading = false;
      m.redraw();
      // 检查 API 返回的 ret 错误码
      if (response && response.ret !== undefined && response.ret !== 0) {
        app.alerts.show({ type: 'error' }, getErrorMessage(response.ret, response.msg));
        return;
      }
      app.alerts.show({ type: 'success' }, app.translator.trans('laya-auth.forum.sign_up.code_sent_alert'));
    });
  }

  onsubmit(e: Event) {
    e.preventDefault();

    this.loading = true;

    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/laya/forgot',
      body: {
        phone: this.phone(),
        code: this.code(),
        password: this.password(),
      },
      errorHandler: (error: any) => {
        this.loading = false;
        m.redraw();
        // 尝试多种方式获取 ret 错误码和 msg
        const ret = error?.response?.ret ?? error?.responseJSON?.ret ?? error?.body?.ret ?? error?.ret;
        const msg = error?.response?.msg ?? error?.responseJSON?.msg ?? error?.body?.msg ?? error?.msg;
        if (ret !== undefined && ret !== null) {
          app.alerts.show({ type: 'error' }, getErrorMessage(ret, msg));
          return;
        }
        this.onerror(error);
      },
    }).then((response: any) => {
      // 检查 API 返回的 ret 错误码
      if (response && response.ret !== undefined && response.ret !== 0) {
        this.loading = false;
        m.redraw();
        app.alerts.show({ type: 'error' }, getErrorMessage(response.ret, response.msg));
        return;
      }
      this.loading = false;
      window.location.reload();
    });
  }
}
